
var host = window.location.host;
var sub = host.split('.')[0];
if(sub == 'academy') { 
    document.location.href = 'https://www.strategy-frame.com/pages/academy';
}

window.addEventListener(
  "load",
  function () {
    var backButtons = document.querySelectorAll(".browser-back");
    for (var i = 0, len = backButtons.length; i < len; i++) {
      var backButton = backButtons[i];
      backButton.onclick = function (e) {
        e.preventDefault();
        history.back();
      };
    }
  },
  false
);

window.addEventListener("load", function () {
  if (window.location.hash == "") {
    return false;
  }
  var el = document.querySelector(window.location.hash);
  if (el !== null) {
    setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 1000);
  }
});
